import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=27ad4d1a&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=27ad4d1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad4d1a",
  null
  
)

export default component.exports